import "../../../src/Components/ResetPassword/styles.less";

import React from "react";

import { withApollo } from "../../../lib/apollo3";
import { withAuth } from "../../../lib/auth";
import { withContext } from "../../../lib/context";
import { withGlobalComponents } from "../../../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../../../shared-components/i18n";

import { useResetPassword } from "../../../src/Components/ResetPassword/hook";
import { ResetPasswordLayout } from "src/Components/ResetPassword/components";

// Page RecuperarContrasena
const RecuperarContrasena = () => {
	const {
		form,
		changePassword,
		validate: { validateForm, validateRules },
	} = useResetPassword();

	return (
		<ResetPasswordLayout
			form={form}
			changePassword={changePassword}
			validateForm={validateForm}
			validateRules={validateRules}
		/>
	);
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(RecuperarContrasena))), {
		withDummyContext: false,
		withFiltersContext: false,
		withConfigContext: true,
		withThemeContext: true,
	})
);
